export default "__VITE_ASSET__CARwBAH4__"